import ExcelJS from 'exceljs';
import { minutosAHora } from '../horarios/time';
import { DIAS_TODOS } from './parseAcomodamientoExcel';

const COLOR_ENCABEZADO = 'FF1F4E78'; // azul oscuro
const COLOR_FILA_PAR = 'FFEAF1F8'; // azul muy claro, para el efecto zebra

function formatFecha(fecha) {
  if (!fecha) return '';
  const dia = String(fecha.getUTCDate()).padStart(2, '0');
  const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
  const anio = fecha.getUTCFullYear();
  return `${dia}/${mes}/${anio}`;
}

// Crea una hoja a partir de un arreglo de objetos planos, con encabezado con color,
// texto en blanco/negritas, filtro, columnas congeladas y franjas "zebra" en los datos.
function crearHojaEstilizada(workbook, nombreHoja, filasObjetos, anchoPorClave = {}) {
  const sheet = workbook.addWorksheet(nombreHoja.slice(0, 31));
  const claves = filasObjetos.length > 0 ? Object.keys(filasObjetos[0]) : [];

  sheet.columns = claves.map((clave) => ({
    header: clave,
    key: clave,
    width: anchoPorClave[clave] ?? Math.max(10, clave.length + 2),
  }));

  filasObjetos.forEach((fila) => sheet.addRow(fila));

  const filaEncabezado = sheet.getRow(1);
  filaEncabezado.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: COLOR_ENCABEZADO } };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
  });
  filaEncabezado.height = 20;

  for (let numFila = 2; numFila <= filasObjetos.length + 1; numFila += 1) {
    if (numFila % 2 === 0) {
      sheet.getRow(numFila).eachCell({ includeEmpty: true }, (cell) => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: COLOR_FILA_PAR } };
      });
    }
  }

  sheet.views = [{ state: 'frozen', ySplit: 1 }];

  if (claves.length > 0) {
    sheet.autoFilter = {
      from: { row: 1, column: 1 },
      to: { row: filasObjetos.length + 1, column: claves.length },
    };
  }

  return sheet;
}

function descargarWorkbook(workbook, nombreArchivo) {
  return workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);
    const enlace = document.createElement('a');
    enlace.href = url;
    enlace.download = nombreArchivo;
    document.body.appendChild(enlace);
    enlace.click();
    enlace.remove();
    URL.revokeObjectURL(url);
  });
}

const ANCHOS_HOJA_PRINCIPAL = {
  SEMESTRE: 10,
  ID: 10,
  AULA: 10,
  'HORA INICIO': 12,
  'HORA FIN': 12,
  'FECHA INICIO': 13,
  'FECHA FIN': 13,
  ...Object.fromEntries(DIAS_TODOS.map((dia) => [dia, 10])),
};

export async function exportarAcomodamiento(propuestas, nombreArchivo = 'acomodamiento_salones.xlsx') {
  const workbook = new ExcelJS.Workbook();

  propuestas.forEach((propuesta) => {
    const filasHoja = propuesta.filasSalida.map((f) => {
      const fila = {
        SEMESTRE: f.semestre,
        ID: f.id,
        AULA: f.aula,
        'HORA INICIO': minutosAHora(f.horaInicioMin),
        'HORA FIN': minutosAHora(f.horaFinMin),
      };
      DIAS_TODOS.forEach((dia) => {
        fila[dia] = f.dias.includes(dia) ? 'X' : '';
      });
      fila['FECHA INICIO'] = formatFecha(f.fechaInicio);
      fila['FECHA FIN'] = formatFecha(f.fechaFin);
      return fila;
    });
    crearHojaEstilizada(workbook, propuesta.nombre, filasHoja, ANCHOS_HOJA_PRINCIPAL);
    crearHojaEstilizada(workbook, `Mapa ${propuesta.nombre}`, propuesta.gridOcupacion, { AULA: 10 });
  });

  const filasResumen = [];
  propuestas.forEach((propuesta) => {
    propuesta.sinAsignar.forEach((s) => {
      filasResumen.push({
        Opción: propuesta.nombre,
        SEMESTRE: s.semestre,
        ID: s.id,
        Motivo: s.motivo,
      });
    });
  });

  const totalSinAsignar = filasResumen.length;
  if (totalSinAsignar === 0) {
    filasResumen.push({ Resultado: 'Todas las filas recibieron un salón sin choques en todas las opciones.' });
  }
  crearHojaEstilizada(workbook, 'Resumen', filasResumen, { Motivo: 60, Resultado: 60 });

  await descargarWorkbook(workbook, nombreArchivo);

  return { totalSinAsignar };
}
